import React, { Fragment } from 'react';
import * as BuilderUI from '../../../../components/Builder/BuilderUI';
import { useAppSelector } from '../../../../redux/hooks';
import { CohortRow } from '../../../../components/Builder/Cohorts';
import { RowType } from '../../../../redux/slices/oldBuilder';
import PredictionEvent from './PredictionEvent';
import { BuilderHeader } from '../../../../components/Builder/BuilderHeader';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import BuilderExecutionDateRange from '../../../../components/Builder/BuilderExecutionDateRange';
import ExecuteReport from '../../../../components/Builder/ExecuteReport';

const PredictionBuilder = () => {
  const predictionCohorts = useAppSelector(
    ({ builder }) => builder[RowType.predictionCohorts],
  );

  return (
    <>
      <BuilderHeader queryType={QueryType.Prediction} />
      <BuilderUI.Part1>
        {predictionCohorts.map((cohortRow, rowIndex) => (
          <Fragment key={`prediction-cohort-row-${rowIndex}`}>
            {rowIndex > 0 && <BuilderUI.HorizontalDivider />}
            <CohortRow
              rowMeta={{
                rowType: RowType.predictionCohorts,
                rowIndex,
              }}
              cohortRow={cohortRow}
              allowRemove={false}
            />
          </Fragment>
        ))}
      </BuilderUI.Part1>
      <BuilderUI.Part2>
        <PredictionEvent
          rowMeta={{ rowIndex: 1, rowType: RowType.prediction }}
        />
        <BuilderUI.HorizontalDivider />
        <BuilderExecutionDateRange />
      </BuilderUI.Part2>
      <ExecuteReport />
    </>
  );
};

export default PredictionBuilder;
